"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeMentionsAndMessageForDisplay = void 0;
var lodash_1 = __importDefault(require("lodash"));
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var mergeMentionsAndMessageForDisplay = function (mentions, message, usersInAccount, pendingUsers) {
    var sortedMentions = lodash_1.default.orderBy(mentions, function (mention) { return mention.location; }, ["desc"]);
    message = sortedMentions.reduce(function (prevValue, currentMention) {
        var displayName = getMentionDisplayName(currentMention, usersInAccount, pendingUsers);
        var prefix = prevValue.substring(0, currentMention.location);
        var suffix = prevValue.substring(currentMention.location);
        var nextString = "".concat(prefix, "{{$$mention:").concat(displayName, "}}").concat(suffix);
        return nextString;
    }, message);
    return message;
};
exports.mergeMentionsAndMessageForDisplay = mergeMentionsAndMessageForDisplay;
var getMentionDisplayName = function (mention, usersInAccount, pendingUsers) {
    var mentionedUser = usersInAccount.find(function (user) { return matchUserInAccount(user, mention); });
    if (mentionedUser != null) {
        return (0, GetFullName_1.default)(mentionedUser);
    }
    else {
        var mentionedPendingUser = pendingUsers.find(function (s) { return s.id == mention.userId; });
        if (mentionedPendingUser != null) {
            return mentionedPendingUser.email;
        }
        else if (mention.email) {
            return mention.email;
        }
        else {
            return "Unknown user";
        }
    }
};
var matchUserInAccount = function (user, mention) {
    if (user._id == mention.userId) {
        return true;
    }
    else if (user.useHistory && user.useHistory.signup && user.useHistory.signup.inviteId == mention.userId) {
        return true;
    }
    else {
        return false;
    }
};
